export default {
  methods: {
    areSameName(x, y) {
      return ((x != null && y != null) && (x.toLowerCase() === y.toLowerCase()))
    },
  },
  computed: {

  },
}